import { Col, AccordionItem, Accordion, AccordionBody, AccordionHeading, AccordionTitle, Typography, Icon, Link } from "@visa/vds"
import React, { useEffect, useState } from "react";
import DashboardActionItemsDialog from "../DashboardActionItemsDialog";
import VstsAccessStatus from "pages/CertificationWorkflow/SharedComponents/VstsAccessStatus";

const CertificationPackageDashboardAccordion = (props) => {
    const [openDialog, setOpenDialog] = useState(false);

    let {
        accordionHeaderActionComponent,
        access,
        title
    } = props

    useEffect(() => {
    }, [access]);

    return (
        <>
            <DashboardActionItemsDialog
                openDialog={openDialog}
                setOpenDialog={setOpenDialog}
                accordionHeaderActionComponent={accordionHeaderActionComponent} />

            <Accordion className="dashboard-accordion" id={title}>
                <AccordionItem>
                    <AccordionHeading>
                        <Col>
                            <AccordionTitle className="vss-accordion-title-dashboard">
                                <div className="certification-package-title-subtitle">
                                    <Typography className="certification-package-title" tag="h3" variant="title" id={"accordian_title_" + title}>{title}</Typography>
                                    <div className="dashboard-vsts-access">
                                        <VstsAccessStatus vstsAccessDescriptionNo={props.vstsAccessStatusDescriptionNo} className="dashboard-web-view vsts-status" vstsAccess={props.vstsAccess} vstsAccessDescription={props.vstsAccessDescription} />
                                    </div>
                                </div>
                                {props.isExternalUser &&
                                    <div className="certification-package-accordion-action-items">
                                        {props.accordionHeaderActionComponent}
                                    </div>
                                }
                            </AccordionTitle>
                        </Col>
                    </AccordionHeading>
                    <AccordionBody className="dashboard-accordion-body">
                        {props.children}
                    </AccordionBody>
                </AccordionItem>
            </Accordion >
        </>
    );
}
export default CertificationPackageDashboardAccordion;